import type { AgentSkill } from "@common/schemas/domains/agentSkills/agent-skill.schema";
import { AgentSkillKind } from "@common/types/agentSkill";
import { Button } from "@design-system/Button/Button";
import { HStack } from "@design-system/HStack/HStack";
import { Menu } from "@design-system/Menu/Menu.lib";
import { RESET_TO_DEFAULT_LABEL } from "./agentSkillCopy";
import styles from "./AgentSkills.module.scss";

export interface AgentSkillLifecycleProps {
    skill: AgentSkill;
    canManage: boolean;
    onReset: () => void;
    onEnable: () => void;
    onDisable: () => void;
    onDelete: () => void;
}

/** Reset for a customized Kick skill; the Actions menu for a firm skill. */
export const AgentSkillLifecycleActions = ({
    skill,
    canManage,
    onReset,
    onEnable,
    onDisable,
    onDelete,
}: AgentSkillLifecycleProps) =>
    skill.kind === AgentSkillKind.KICK ? (
        skill.isCustomized && (
            <Button
                type="button"
                variant="secondary"
                size="md"
                disabled={!canManage}
                onClick={onReset}
            >
                {RESET_TO_DEFAULT_LABEL}
            </Button>
        )
    ) : (
        <Menu.Root
            trigger={
                <Button type="button" variant="secondary" size="md">
                    Actions
                </Button>
            }
        >
            {skill.isEnabled ? (
                <Menu.Item disabled={!canManage} onClick={onDisable}>
                    Disable
                </Menu.Item>
            ) : (
                <Menu.Item disabled={!canManage} onClick={onEnable}>
                    Enable
                </Menu.Item>
            )}
            <Menu.Item destructive disabled={!canManage} onClick={onDelete}>
                Delete
            </Menu.Item>
        </Menu.Root>
    );

interface Props extends AgentSkillLifecycleProps {
    onShowVersions: () => void;
}

/** The command island's read-mode row: members who cannot edit. */
export const AgentSkillReadActions = ({
    onShowVersions,
    ...lifecycle
}: Props) => (
    <>
        <Button
            type="button"
            variant="secondary"
            size="md"
            onClick={onShowVersions}
        >
            Version history
        </Button>
        <span className="text-secondary">
            Version {lifecycle.skill.currentVersion}
        </span>
        <HStack gap={8} className={styles.islandEnd}>
            <AgentSkillLifecycleActions {...lifecycle} />
        </HStack>
    </>
);
